module.exports = __webpack_public_path__ + "img/iran.f6903c10.svg";